import { render } from "./GuestStatusBarFooter.vue?vue&type=template&id=a6fbdbe0"
import script from "./GuestStatusBarFooter.vue?vue&type=script&lang=js"
export * from "./GuestStatusBarFooter.vue?vue&type=script&lang=js"

import "./GuestStatusBarFooter.vue?vue&type=style&index=0&id=a6fbdbe0&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__